import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal, Eyebrow } from "@/components/motion";
import { AGENCY, waLink } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

const ContattiPage = () => {
  const { t } = useLang();

  const channels = [
    {
      icon: Phone, title: t("cont.phone"), value: AGENCY.phone, note: t("cont.phoneNote"),
      href: AGENCY.phoneHref, testid: "contact-phone-card",
      cls: "bg-[#000000] text-[#FAFAF7] hover:bg-[#000000]",
    },
    {
      icon: MessageCircle, title: t("cont.wa"), value: t("cont.waValue"), note: t("cont.waNote"),
      href: waLink("Buongiorno ROMACASA, vorrei fissare un appuntamento."), testid: "contact-whatsapp-card",
      cls: "bg-[#25D366] text-white hover:bg-[#1eb857]",
    },
    {
      icon: Mail, title: t("cont.email"), value: AGENCY.email, note: t("cont.emailNote"),
      href: `mailto:${AGENCY.email}`, testid: "contact-email-card",
      cls: "bg-white border border-[#E0E3E6] text-[#000000] hover:border-[#000000]",
    },
  ];

  return (
    <div data-testid="contatti-page" className="pt-36 sm:pt-40 pb-24">
      <Seo
        title={t("seo.contTitle")}
        siteName="ROMACASA"
        description={t("seo.contDesc")}
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Eyebrow>{t("cont.eye")}</Eyebrow>
          <h1 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl font-medium leading-tight mt-4 mb-6">
            {t("cont.t1")} <span className="italic">{t("cont.t2")}</span>
          </h1>
          <p className="text-[#5B6670] font-light text-base sm:text-lg leading-relaxed">{t("cont.sub")}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-14">
          {channels.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <a
                href={c.href}
                target={c.href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                data-testid={c.testid}
                className={`block p-8 h-full transition-colors duration-300 group ${c.cls}`}
              >
                <c.icon size={26} className="mb-6" />
                <p className="text-xs font-semibold uppercase tracking-[0.25em] opacity-70 mb-2">{c.title}</p>
                <p className="font-serif-d text-2xl font-medium mb-3">{c.value}</p>
                <p className="text-sm font-light opacity-80 leading-relaxed">{c.note}</p>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-16">
            <div className="bg-[#F1F2F4] border border-[#E0E3E6] p-8 sm:p-10">
              <img src="/icon-arch-dark.png" alt="Icona ROMACASA — le arcate del Colosseo Quadrato" className="w-16 h-auto mb-7" data-testid="brand-icon" />
              <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-[#000000] mb-6">
                <MapPin size={15} /> {t("cont.sede")}
              </p>
              <p className="font-serif-d text-2xl sm:text-3xl font-medium mb-3">{AGENCY.address} — EUR</p>
              <p className="text-[#5B6670] font-light text-sm leading-relaxed max-w-md">{t("cont.sedeText")}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default ContattiPage;
